import { useMemo } from 'react'

import { flattenKubernetesTargetsWithOwnerId } from 'components/attacks/create/targets/kubernetes/kubernetes-target-utils'
// Ignore until eslint-plugin-jsdoc is configured
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { type ServiceKubernetesTargetingSelection } from 'components/services/create/target-selection/kubernetes/ServiceKubernetesTargetingSelection'
import { activeK8sClientSelector, useK8sClientsStore } from 'hooks/use-clients'
import { useGetFormattedK8sTargetingData } from 'hooks/use-get-formatted-k8s-targeting-data'

import type { K8sObjectWithOwningTeamId } from 'types/api/kubernetes/kubernetes'

/**
 * Retrieves a record of Kubernetes targeting objects grouped by their label keys based on the
 * Kubernetes client data available in the store.
 * @see {@link ServiceKubernetesTargetingSelection} for usage example
 */
export function useGetKubernetesTargetsByOwnerId() {
  const k8sClients = useK8sClientsStore(activeK8sClientSelector)
  const k8sObjects = useMemo(
    () => flattenKubernetesTargetsWithOwnerId(k8sClients),
    [k8sClients]
  )

  // NOTE: return object of this hook is memoized from within
  const formattedK8sTargets =
    useGetFormattedK8sTargetingData<K8sObjectWithOwningTeamId>(k8sObjects)

  return useMemo(
    () => ({ ...formattedK8sTargets, k8sObjects }),
    [k8sObjects, formattedK8sTargets]
  )
}
